import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const deliverySummary = css`
  display: flex;
  column-gap: ${spacing.sm}px;
  justify-content: space-between;
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${responsiveText.BODY.MD};
  text-decoration: none;

  ul {
    flex-grow: 1;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    color: var(--neutral-black-70);

    &:first-child {
      color: var(--neutral-black-base);
    }
  }

  small {
    ${responsiveText.BODY.SM};

    b {
      color: var(--brand-bluple-base);
    }
  }
`;
